module.exports = __webpack_public_path__ + "static/media/icon-Hipercard.f0a78e11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-Hipercard.svg
// module id = 2904
// module chunks = 0